
/**
 * GSC LATENCY UNIT GOVERNANCE
 * Authority: Senior Reliability Engineer
 */

export function normalizeHardwareLagMs(input: unknown): number {
    if (input === null || input === undefined) return 0;

    // 1. Conversion string (comma safety)
    let val: number;
    if (typeof input === 'string') {
        val = parseFloat(input.replace(',', '.'));
    } else if (typeof input === 'number') {
        val = input;
    } else {
        return 0;
    }

    if (!Number.isFinite(val)) return 0;

    const original = val;

    // 2. Unification Logic (Galactic Lag Fix)
    // Range attendu: 0..800ms
    if (val > 2000) {
        if (val > 2000000) {
            val = val / 1000000; // Nanoseconds -> Ms
        } else if (val > 2000) {
            val = val / 1000; // Microseconds (ou double conversion) -> Ms
        }
    }

    // 3. Fail-safe Clamp
    const finalVal = Math.min(800, Math.max(0, val));

    // 4. Contract Log
    if (Math.abs(original - finalVal) > (finalVal * 9)) {
        console.warn(`[LAG_NORMALIZED] High drift detected. Before: ${original}, After: ${finalVal}ms`);
    }

    return finalVal;
}
